import AreaCities from "@/components/AreaCities";
import CtaBand from "@/components/CtaBand";
import { Marquee } from "@/components/Marquee";
import { PHONE_DISPLAY } from "@/constants/site";

const ServiceArea = () => (
  <>
    <section className="bg-asphalt py-20 sm:py-28 grain relative" data-testid="service-area-page-hero">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="font-mono text-xs tracking-[0.3em] text-emergency uppercase">Service Area</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[1.02] text-white">
          Every mile of<br /><span className="text-emergency">Tarrant County.</span>
        </h1>
        <p className="mt-6 max-w-xl text-lg text-zinc-400">
          I-35W, I-30, I-20, TX-121 and everywhere in between. Text your pin to {PHONE_DISPLAY} for an instant ETA.
        </p>
      </div>
    </section>
    <Marquee />
    <AreaCities full />
    <CtaBand />
  </>
);

export default ServiceArea;
